import { BaseResponse } from "app/response/internal/baseresponse";

export class Statistics {}

export class CustomerStatistics {
  year: string = "";
  month: string = "0";
  summary: string = "0";
  count: string = "0";
}

export interface MonthlyStat {
  summary: number;
  count: number;
}

export class CustomerYearStatisticsResponse {
  year: number;

  /** 작년 12월 이월 */
  carryOver: MonthlyStat;

  /** 월별 통계 (01 ~ 12) */
  monthly: {
    [month: string]: MonthlyStat;
  };
}

export class CustomerStatisticsResponse extends BaseResponse {
  data!: CustomerYearStatisticsResponse;
}

export class CustomerStatisticsRow {
  label: string = ""; // "2025-01", "Carry Over"
  summary: number = 0;
  count: number = 0;
}



// WEBPACK FOOTER //
// ./src/app/model/shared/statistics.ts